module.exports = __webpack_public_path__ + "img/consult.fde779b2.jpg";